// extracted by mini-css-extract-plugin
export default {"calc":"calc_calc__8y+dJ"};